import api from '../../config/axios.js';

const state = {
    salesList: [],
    salesPagination: {
        current_page: 1,
        last_page: 1,
        per_page: 10,
        total: 0,
    },
    salesSearchList: [],
    currentViewSale: {},
    sellers: [],
    salesProductsList: [],
    salesContacts: []
}

const getters = {
    getSalesList: state => state.salesList,
    getSalesPagination: state => state.salesPagination,
    getSalesSearchList: state => state.salesSearchList,
    getCurrentViewSale: state => state.currentViewSale,
    getSellers: state => state.sellers,
    getSalesProductsList: state => state.salesProductsList,
    getSalesContacts: state => state.salesContacts
}

const actions = {
    // LISTANDO VENDAS
    async setSalesList({ commit }, payload = {}){
        const page = typeof payload === 'object' ? (payload.page || 1) : payload;
        const month = typeof payload === 'object' ? payload.month : null;
        const year = typeof payload === 'object' ? payload.year : null;
        const monthFilter = month && year ? `&month=${month}&year=${year}` : '';

        await api.axios.get(`/api/sales?page=${page}${monthFilter}`).catch(() => {
            commit("setSalesList", []);
            commit("setSalesPagination", {
                current_page: 1,
                last_page: 1,
                per_page: 10,
                total: 0,
            });
        }).then((response) => {
            if(response && response.data){
                const payload = response.data;
                const list = Array.isArray(payload.data) ? payload.data : payload;
                const pagination = Array.isArray(payload.data)
                    ? {
                        current_page: payload.current_page || page,
                        last_page: payload.last_page || 1,
                        per_page: payload.per_page || list.length,
                        total: payload.total || list.length,
                    }
                    : {
                        current_page: 1,
                        last_page: 1,
                        per_page: list.length,
                        total: list.length,
                    };

                commit("setSalesList", list);
                commit("setSalesPagination", pagination);
            }
        });
    },
    async setCurrentViewSale({ commit }, data){
        commit('setCurrentViewSale', data);
    },
    async setSalesSearchList({ commit }, payload){
        const search = typeof payload === 'object' ? payload.search : payload;
        const month = typeof payload === 'object' ? payload.month : null;
        const year = typeof payload === 'object' ? payload.year : null;

        if(!search || search.length < 2){
            commit("setSalesSearchList", []);
            return;
        }

        const monthFilter = month && year ? `&month=${month}&year=${year}` : '';

        await api.axios.get(`/api/sales/search?search=${encodeURIComponent(search)}${monthFilter}`).catch(() => {
            commit("setSalesSearchList", []);
        }).then((response) => {
            if(response && response.data){
                commit("setSalesSearchList", Array.isArray(response.data) ? response.data : []);
            }
        });
    },
    async setSellers({ commit }){
        await api.axios.get('/api/users').catch(() => {
            commit("setSellers", []);
        }).then((response) => {
            if(response && response.data){
                commit("setSellers", response.data);
            }
        });
    },
    async setSalesProductsList({ commit }, search = ''){
        const endpoint = search && search.length >= 2
            ? `/api/products/search/${encodeURIComponent(search)}`
            : '/api/products?page=1';

        await api.axios.get(endpoint).catch(() => {
            commit("setSalesProductsList", []);
        }).then((response) => {
            if(response && response.data){
                const payload = response.data;
                const list = Array.isArray(payload.data)
                    ? payload.data.filter(Boolean)
                    : (Array.isArray(payload) ? payload.filter(Boolean) : []);

                commit("setSalesProductsList", list);
            }
        });
    },
    async setSalesContacts({ commit }, client){
        try {
            const response = await api.axios.get(`/api/search/client/phone/${encodeURIComponent(client)}`);
            commit('setSalesContacts', response.data || []);
        } catch (error) {
            if (error.response && error.response.status === 404) {
                commit('setSalesContacts', []);
                return;
            }
            console.error('Erro ao buscar clientes de vendas:', error);
            commit('setSalesContacts', []);
        }
    }
}

const mutations = {
    setSalesList: function(state, data){
        state.salesList = data;
    },
    setSalesPagination: function(state, data){
        state.salesPagination = data;
    },
    setSalesSearchList: function(state, data){
        state.salesSearchList = data;
    },
    setCurrentViewSale: function(state, data){
        state.currentViewSale = data;
    },
    setSellers: function(state, data){
        state.sellers = data;
    },
    setSalesProductsList: function(state, data){
        state.salesProductsList = data;
    },
    setSalesContacts: function(state, data){
        state.salesContacts = data;
    }
}

export default {
    state,
    getters,
    actions,
    mutations
}
